export default {
  getList: (state) => state.list,
  getPageInfo: (state) => state.pageInfo,
  getCondition: (state) => state.condition,
  getTotalCoupon: (state) => state.totalCoupon
};
